<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-24T15:54:30+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe
@Last modified by:   tom
@Last modified time: 2019-05-16T12:29:25+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

Shows a carousel / slideshow. Example:

  <slideshow
    :slides="[
      'seniors-alone.jpg',
      'unexpected-moments.jpg',
      'safe-connected.jpg',
      'mutual-care.jpg'
    ]"
    folder="img/carousel/"
    width="1200"
    height="600"
    label-pre-fix="puck.about"
  />

To provide link, <router-link :to="{name:'Services'}"> <slideshow ... /> </router-link>
-->

<template>
  <b-carousel id="carousel-panel"
              :interval="4000"
              :img-width="width"
              :img-height="height"
              v-model="slide"
              class="d-block mx-auto"
              controls
              indicators

              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd" >

    <!-- Text slides with image -->
    <!-- because wrapping inside a <b-carousel-slide> does not work: hardcode the expanded template -->
    <div
      v-for="f in slides.length"
      :key="f"
      class="carousel-item"
      role="listitem">
      <!-- show the carousel slides. First img never lazy to force size of div in browser -->
      <lzimg
        :src="`${folder}${slides[f-1]}`"
        :no-lazy="f===1"
        :width="width"
        :height="height"
        fluid-grow
        block />
      <!-- blanksrc="img/blank.gif" -->
      <div
        v-if="$te(`${labelPreFix}.${f}.title`)"
        class="carousel-caption">
        <h3>{{ $t(`${labelPreFix}.${f}.title`) }}</h3>
        <p>{{ $t(`${labelPreFix}.${f}.caption`) }}</p>
      </div>
    </div>

  </b-carousel>
</template>

<script>
import invokeScrollEvent from '@/components/_shared/invokeScrollEvent'

export default {
  name: 'Carousel',
  props: {
    folder: {
      type: String,
      default: '/static'
    },
    width: {
      type: String,
      default: '1200'
    },
    height: {
      type: String,
      default: '600'
    },
    slides: {
      type: Array, // fontawesome key, "check", "user-o",...
      default: () => ['empty-slide.jpg']
    },
    labelPreFix: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      slide: 0,
      nrScrolls: 1
    }
  },
  methods: {
    onSlideStart () {
      // for lazy loading, we invoke scroll event for each slide once
      // but only if in viewport
      if (this.nrScrolls <= this.slides.length &&
        isElementInViewport(document.getElementById('carousel-panel'))) {
        // we did not lazy load all slides yet
        invokeScrollEvent('Sales deck slide ' + this.nrScrolls, 200)
        this.nrScrolls++
      }
    },
    onSlideEnd () {
      //
    }
  }
}

// Booleand test if part of an element is visible (only works vertically)
function isElementInViewport (el) {
  var rect = el.getBoundingClientRect()
  return (
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth))
}

</script>

<style lang="scss">

#carousel-panel {
  // on wide screens we like to keep the carousel not too large
  // note the classes class="d-block mx-auto" on the <b-carousel ... >
  max-width: 1110px;
  border: 1px solid #999;
  text-shadow: 2px 2px 4px #333;

  .carousel-control-next,
  .carousel-control-prev {
    z-index: 20 ;
  }

  @media (min-width:1200px) {
    // we can show next/prev button next to slides on wide screen
    .carousel-control-next {
      right: -30px;
    }
    .carousel-control-prev {
      left: -30px;
    }
  }

  .carousel-item {
  // to avoid starting too small and screen flash while loading first image
  //   Gives problem on very small screens.... ?
    min-height: 110px;
  }
  .carousel-caption {
    left: 0;
    right: 0;
    bottom: 0;
    padding-top: 0;

    // shadow under the text / caption
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#4c4c4c+0,131313+100&0+0,0.71+100 */
    background: -moz-linear-gradient(top, rgba(76,76,76,0) 0%, rgba(19,19,19,0.71) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, rgba(76,76,76,0) 0%,rgba(19,19,19,0.71) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, rgba(76,76,76,0) 0%,rgba(19,19,19,0.71) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#004c4c4c', endColorstr='#b5131313',GradientType=0 ); /* IE6-9 */

    h3 {
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }
  .carousel-indicators {
    // the little slide bars at the bottom   -----
    bottom: -10px;
    li {
      background-color: #888;
    }
    li.active {
      background-color: #BBB;
    }
  }
}
</style>
